

















import { Component, Prop, Vue } from "vue-property-decorator"
import { Expositor } from "@/Interfaces/Programa/Expositor";
import { Material } from "@/Interfaces/Programa/Material";
import AppProgramaExpositores from "@/components/Programa/AppProgramaExpositores.vue";
import AppProgramaMaterial from "@/components/Programa/AppProgramaMaterial.vue";

@Component({
  components: {
    AppProgramaMaterial,
    AppProgramaExpositores
  }
})
export default class ProgramaGrupoPresentacion extends Vue {
  @Prop({ required: true }) hora: string;
  @Prop({ required: true }) titulo: string;
  @Prop({ required: false }) descripcion: string;
  @Prop({ required: false }) expositores: Expositor[];
  @Prop({ required: false }) materiales: Material[];

}
